import styles from "./StockShowcaseComponent.module.css";

export default function StockPortfolioMangerShowcaseComponent() {
	return (
		<>
			<div className={styles.project}>
				<div>
					<h1 className={styles.name}>Stock Portfolio Manager</h1>
					<h3>
						Skills used: React, Next.js, TypeScript, Prisma ORM,
						ShadCn, Next-Auth, Next-Intl, Tailwind CSS
					</h3>
					<h3>Database: Neon Severless PostgreSQL</h3>
					<h3>APIs: Marketstack</h3>
				</div>
				<div>
					<h1 className={styles.name}>Overview</h1>
					<p>
						A site where users can practice buying and selling
						stocks. Users can login using their gmail to save their
						mock portfolio. The site uses the marketstack api so the
						prices of the user's stocks are accuarate. In addition,
						the portfolio chart can track a hundred days of a
						stock's perfomance with accurate figures in USD. Users
						can own up to 4 distinct stocks and 3 seperate buy
						orders of a given stock. This data is stored using Neon
						serverless postgress and intuitively interacts with my
						Next.js app using Prisma ORM. The site also supports
						language translation in English, Spanish and French
						using the next-intl library.
					</p>
					<a
						className={styles.button}
						href="https://github.com/benwesson/ben_stock_dashboard"
					>
						See GitHub
					</a>
				</div>
				<div>
					<h1 className={styles.name}>Account</h1>
					<p>
						The Account page features a chart componet and table
						componet. The chart componet lets the user see a 100 day
						historic stock price summary charted for each of their
						owned stocks. The marketstack API is used to fetch
						accurate stock price data in USD. The price used for
						each data point is the stock's closing price for that
						day. The request is cached using Next.js's caching to
						improve performance and reduce load on the API. The
						table component displays the user's owned stocks
						including the shares purchased per order, the price at
						purchase, the current price, a gain loss caluclation and
						the order ID which can be used to sell the postion.
					</p>
				</div>
				<div>
					<h1 className={styles.name}>Funds</h1>
					<p>
						The funds page allows the users to add up to a simulated
						1 million dollars in USD to their mock portfolio. When
						users buy and sell mock stocks this value adjusts. If a
						user tries to buy a stock without the appropriate funds
						the server will prevent this. The site uses a zod schema
						to perform server validation on the amount being
						deposited to demonstrate good validation practices.
					</p>
				</div>
				<div>
					<h1 className={styles.name}>Buy</h1>
					<p>
						The buy page allows users to search for stocks by ticker
						and then place a buy order within the site guidelines.
						Users can own 4 distinct stocks, place buy orders of up
						to 100 shares per stock, and have 3 buy orders per
						stock. Server side validation is performed using a zod
						schema to ensure these guidelines are followed. The
						react useActionState hook is used to dispaly error
						messages to the user. The server validation occurs in 2
						stages. First the server uses the marketstack API to
						verify the ticker exists and then returns price
						information. The server then validates the users intent
						based on the site guidlines. I decied to implemnt these
						guidleines to reduce api load and database volume.
					</p>
				</div>
				<div>
					<h1 className={styles.name}>Sell</h1>
					<p>
						The sell page allows users to sell owned stocks by
						orderID. Like the buy apge, the server will prevent
						troublsome actions from the user such as selling more
						shares than owned or selling an orderID that does not
						exist. The server uses a zod schema to perform
						validation and the react useActionState hook to display
						error messages to the user. A planned future feature
						would be a sell all button.
					</p>
				</div>
				<div>
					<h1 className={styles.name}>Login</h1>
					<p>
						The login page allows users to securely login using
						their gmail account. Next-Auth is used to handle the
						oauth process and session managment. It works seamlessly
						with the Prisma ORM adapter to associate users with their
						portfolio in my database.
					</p>
					
				</div>
			</div>
		</>
	);
}
